import React from 'react';
import { Text, Link, Box, useTheme } from '@ublend-npm/aulaui-core';

const LearnMoreLink = () => (
  <Link
    href="https://aula.zendesk.com/hc/en-us/articles/15852659347218"
    fontFamily="Roboto, sans-serif"
    fontSize=".875rem"
  >
    Find out more
  </Link>
);

const StarSpaceOnboarding = () => {
  const { palette } = useTheme();
  return (
    <Box display="flex" justifyContent="center" padding="1rem 0 1.5rem 0">
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        sx={{
          borderRadius: '0.5rem',
          backgroundColor: `${
            palette?.mode === 'dark'
              ? 'rgba(35, 31, 41, 1)'
              : 'rgba(248, 247, 249, 1)'
          } !important`,
          marginLeft: '1rem',
          marginRight: '1rem',
          height: '127px',
        }}
        width="100%"
      >
        <Text kind="p2" pt="1rem" pb=".25rem" fontWeight="600" fontSize="1rem">
          No starred spaces
        </Text>
        <Text
          fontSize=".875rem"
          pl=".5rem"
          pr=".5rem"
          pb=".25rem"
          fontWeight="400"
          textAlign="center"
          lineHeight="143%"
          color={
            palette?.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.7)'
              : 'rgba(0, 0, 0, 0.6)'
          }
        >
          Tap the star icon next to a space name <br /> to add it to the menu
          for quick access
        </Text>
        <LearnMoreLink />
      </Box>
    </Box>
  );
};

export default StarSpaceOnboarding;
